import { createSlice } from '@reduxjs/toolkit';

// todo: need to remove once api is done
const reducerName = 'jobsReferrals';
const initialState = {
  searchTerm: null,

  filters: {
    ats_office_ids: [],
    kinds: [],
    workplaces: [],
    employment_types: [],
    ats_department_ids: [],
    isFilterApplied: false,
  },
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Launched (Newest to oldest)',
    value: 'DESC',
    element: 'launch_at',
    order: 'DESC',
  },
};

const { reducer, actions: jobsReferralsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    applyFilter: (state, { payload }) => {
      const { key, value } = payload;
      state.filters[key] = value;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
      state.searchTerm = '';
    },

    applyTopTalent: (state) => {
      state.filters.top_talent = !state.filters.top_talent;
      state.page = { ...initialState.page };
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = Object.values(state.filters).some(
        (filter) => filter !== initialState.filters[key]
      );
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = payload?.searchTerm?.length > 0;
    },
  },
});

export { jobsReferralsActions };
export default reducer;
